// extracted by mini-css-extract-plugin
module.exports = {"productCards":"styles_productCards__kebZL","productCards__Card":"styles_productCards__Card__D51Kb","productCards__Title":"styles_productCards__Title__rutGW"};